import { faker } from "@faker-js/faker";

import type {
  ShowTodo200,
  ShowTodoPathParams,
  ShowTodoQueryResponse,
} from "../models/ShowTodo";
import { createTodo } from "./createTodo";

export function createShowTodoPathParams(
  override: NonNullable<Partial<ShowTodoPathParams>> = {},
): NonNullable<ShowTodoPathParams> {
  return {
    ...{ id: faker.number.int() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createShowTodo200(
  override: NonNullable<Partial<ShowTodo200>> = {},
): NonNullable<ShowTodo200> {
  return {
    ...{ data: createTodo() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createShowTodoQueryResponse(
  override: NonNullable<Partial<ShowTodoQueryResponse>> = {},
): NonNullable<ShowTodoQueryResponse> {
  return {
    ...{ data: createTodo() },
    ...override,
  };
}
